import { Carrello } from "orser-model/Carrello";
import Fetch from "../script/Fetch";

export class ClienteService {
    async getOrdineListByClienteId(clienteId: string) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/ordine`, {
                method: "GET"
            });
            return await response.json();
        } catch (e) {
            console.error(e);
        }
    }

    async setClienteInPayment(clienteId: string, type: string) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/payment`, {
                method: "POST",
                body: {
                    type: type
                }
            });
            await response.json();
        } catch (e) {
            console.error(e);
        }
    }


    async sendOrdineAndSetClienteInPayment(clienteId: string, carrello: Carrello, type: string) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/ordineAndPayment`, {
                method: "POST",
                body: {
                    type: type,
                    carrello: carrello
                }
            });
            await response.json();
        } catch (e) {
            console.error(e);
        }
    }

    async getPaymentClienteByClienteId(clienteId: string) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/payment`, {
                method: "GET"
            });
            return await response.json();
        } catch (e) {
            console.error(e);
        }
    }

    async moveToNextCourse(clienteId: string, ordineId: string) {
        try {
            const response = await Fetch.doFetch(`/cliente/${clienteId}/ordine/${ordineId}/nextCourse`, {
                method: "POST"
            });
            return await response.json();
        } catch (e) {
            console.error(e);
        }
    }

}